import React from 'react';
import { styled } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import { ProductListItem } from '../ProductListItem/ProductListItem.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductList = ({
  products,
  regionName,
  contactLink,
  className,
  hideCtaButton
}) => {
  const { isMobile } = useDevice();
  const ItemWrapper = isMobile ? ItemWrapperMobile : ItemWrapperDesktop;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, products.map((item, index) => /* @__PURE__ */ React.createElement(ItemWrapper, {
    key: index
  }, /* @__PURE__ */ React.createElement(ProductListItem, __spreadProps(__spreadValues({}, item), {
    tracking: regionName ? getTrackingData({
      isTrackContent: true,
      regionName,
      contentName: item.sku,
      target: "productDetail"
    }) : {},
    ctaTracking: regionName && contactLink ? getTrackingData({
      isTrackContent: true,
      regionName,
      contentName: "contactSale",
      target: contactLink,
      payload: JSON.stringify({ sku: item.sku })
    }) : {},
    addToCart: hideCtaButton ? null : item.addToCart
  }))))));
};
const Wrapper = styled.div`
  width: 100%;
`;
const ItemWrapperDesktop = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid #e4e5f0;
  }
`;
const ItemWrapperMobile = styled.div`
  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export { ProductList };
